// src/assets/js/downloadUtils.js
import axios from "axios";
import services from "./services";

/**
 * 下载文件
 * @param {string} url - 下载地址
 * @param {string} fileName - 文件名
 * @param {function} onProgress - 下载进度回调函数
 */
export const downloadFile = async (url, fileName, onProgress) => {
    try {
        const response = await axios({
            method: "get",
            url: url,
            responseType: "blob", // 指定响应类型为 blob
            onDownloadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable && onProgress) {
                    // 计算下载进度
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    onProgress(progress);
                }
            },
        });

        // 创建 Blob 对象
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 创建a标签触发下载
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error("下载失败", error);
        throw new Error("下载失败");
    }
};

/**
 * 下载视频文件
 * @param {string} videoUrl - 视频地址
 * @param {string} fileName - 文件名
 * @param {function} onProgress - 下载进度回调函数
 */
export const downloadVideoFile = async (videoUrl, fileName, onProgress) => {
    try {
        const res = await fetch(videoUrl);
        const reader = res.body.getReader();
        const contentLength = +res.headers.get("Content-Length");
        let receivedLength = 0; // 当前接收到的字节数
        let chunks = []; // 接收到的二进制块
        let brake = true
        while (brake) {
            const { done, value } = await reader.read();
            if (done) break;
            chunks.push(value);
            receivedLength += value.length;
            if (onProgress) {
                const progress = parseInt((receivedLength / contentLength) * 100);
                onProgress(progress);
            }
        }

        // 创建 Blob 对象
        const blob = new Blob(chunks);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 触发下载
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error("视频下载失败", error);
        throw new Error("视频下载失败");
    }
};

/**
 * 获取下载 URL
 * @param {string} apiUrl - API 地址
 * @param {object} params - 请求参数
 * @param {function} onProgress - 下载进度回调函数
 */
export const getDownloadUrl = async (apiUrl, params, onProgress) => {
    try {
        const response = await axios({
            url: services.HOST + apiUrl,
            params: params,
            method: "get",
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable && onProgress) {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    onProgress(progress);
                }
            },
        });

        if (response.data) {
            return window.URL.createObjectURL(new Blob([response.data]));
        }
    } catch (error) {
        console.error("获取下载 URL 失败", error);
        throw new Error("获取下载 URL 失败");
    }
};